// import client from '../../Components/Client';
import service from './service';
import serviceTwo from './serviceTwo';
import { UrlBuilder } from './url-builder';

export const getSelf = async () => {
  const response = await service.get('/users/self');

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const get = async (userId) => {
  if (!userId) return undefined;

  const response = await service.get(`/users/${userId}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
export const getByParent = async (parentId, userId) => {
  if (!userId) return undefined;
  if (!parentId) return undefined;

  const response = await service.get(`/parents/${parentId}/users/${userId}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getByPartner = async (partnerId, userId) => {
  const response = await service.get(`/partners/${partnerId}/users/${userId}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const adminListUsers = async (page, pageSize) => {
  const response = await service.get(`/users?page=${page ?? 0}&pageSize=${pageSize ?? 10}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getRoles = async (userId) => {
  const response = await service.get('/users/self/company-roles?mode=ALL&isDesktop=true');

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return [];
};

export const listByPartner = async (
  partnerId,
  name,
  page,
  pageSize,
  companyId,
  isAdmin = false
) => {
  if (!partnerId) return [];

  const builder = new UrlBuilder(`/partners/${partnerId}/users`);

  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize ?? 10);
  builder.add('companyId', companyId);
  if (isAdmin) {
    builder.add('isAdmin', true);
  }

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByAdmin = async (name, page, pageSize, companyId) => {
  const builder = new UrlBuilder(`/admin/users`);

  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize ?? 10);
  builder.add('companyId', companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllUserByPartner = async (partnerId) => {
  if (!partnerId) return [];
  const builder = new UrlBuilder(`/partners/${partnerId}/users/export-excel`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllUserByAdmin = async () => {
  const builder = new UrlBuilder(`/admin/users/export-excel`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const countByPartner = async (partnerId, { companyId }) => {
  if (!partnerId) return [];

  const builder = new UrlBuilder(`/partners/${partnerId}/users/count`);

  builder.add('companyId', companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const countByAdmin = async ({ companyId }) => {
  const builder = new UrlBuilder(`/admin/users/count`);

  builder.add('companyId', companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const countByParent = async (parentId, { companyId }) => {
  if (!parentId) return [];

  const builder = new UrlBuilder(`/parents/${parentId}/users/count`);

  builder.add('companyId', companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const countByCompany = async (companyId) => {
  if (!companyId) return 0;

  const builder = new UrlBuilder(`/companies/${companyId}/users/count`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return 0;
};

export const update = async (user) => {
  const response = await service.put(`/users/${user.id}`, user);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return response.data;
};

export const updateByPartner = async (partnerId, user) => {
  const response = await service.put(`/partners/${partnerId}/users/${user.id}`, user);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByParent = async (parentId, filter, page, pageSize) => {
  const builder = new UrlBuilder(`/parents/${parentId}/users`);
  builder.add('companyId', filter.companyId);
  builder.add('page', filter.page);
  builder.add('pageId', filter.pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const changeRoleByParent = async ({ parentId, companyId, userId, role }) => {
  const builder = new UrlBuilder(
    `/parents/${parentId}/companies/${companyId}/users/${userId}/role`
  );

  const response = await service.put(builder.toString(), { role: role });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const changeRoleByPartner = async ({ partnerId, companyId, userId, role }) => {
  const builder = new UrlBuilder(
    `/partners/${partnerId}/companies/${companyId}/users/${userId}/role`
  );

  const response = await service.put(builder.toString(), { role: role });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const changeRole = async ({ companyId, userId, role }) => {
  const builder = new UrlBuilder(`/companies/${companyId}/users/${userId}/role`);

  const response = await service.put(builder.toString(), { role: role });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getAccessControl = async (companyId) => {
  const builder = new UrlBuilder(`/access-controls/${companyId}`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const updateAccessControl = async (data) => {
  const response = await service.put(`/access-controls/${data?.id}`, data);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const uploadCameraImage = async (payload) => {
  const response = await service.put('/users/self', payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getManagerUsersList = async (companyId, page, pageSize) => {
  if (!companyId) return [];

  const builder = new UrlBuilder(`/company/${companyId}/roles/manager`);
  builder.add('page', page);
  builder.add('pageId', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return [];
};

export const inviteVisitor = async (companyId, payload, distributorRoleId) => {
  const builder = new UrlBuilder(`/companies/${companyId}/visitor-invitation`);
  builder.add('distributorRoleId', distributorRoleId);

  const response = await service.post(builder.toString(), payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const inviteDistributorByAdmin = async (companyId, payload) => {
  const response = await service.post(`/companies/${companyId}/distributor-invitation`, payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const inviteVisitorViaPhone = async (companyId, payload) => {
  const response = await service.post(`/companies/${companyId}/visitor-sms-invitation`, payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const sentUserInvitationsList = async (page, pageSize) => {
  const response = await serviceTwo.getTwo(
    `/invitations/list-user-invites?page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const confirmUser = async (payload) => {
  const response = await serviceTwo.postTwo(`/auth/confirm-user`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const userDeletion = async (userId) => {
  const builder = new UrlBuilder(`/user/delete-user-account`);
  try {
    const response = await service.post(builder.toString(), { userId });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error?.response?.data;
  }
};

export const userList = async (payload) => {
  const response = await serviceTwo.postTwo(`/user/list-company-users`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getCustomRoleList = async (payload) => {
  const builder = new UrlBuilder(`/custom-roles/get-custom-roles`);

  const response = await serviceTwo.postTwo(builder.toString(), payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getManagerialList = async (payload) => {
  const builder = new UrlBuilder(`/user/list-managerial-roles`);

  const response = await serviceTwo.postTwo(builder.toString(), payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const deleteManagerialList = async (payload) => {
  const builder = new UrlBuilder(`/user/del-managerial-role`);

  const response = await serviceTwo.postTwo(builder.toString(), payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getSelf,
  getRoles,
  get,
  getByPartner,
  getByParent,
  update,
  updateByPartner,
  adminListUsers,
  listByPartner,
  listByParent,
  countByPartner,
  countByParent,
  countByCompany,
  changeRoleByParent,
  changeRoleByPartner,
  changeRole,
  getAccessControl,
  updateAccessControl,
  uploadCameraImage,
  listAllUserByPartner,
  countByAdmin,
  listAllUserByAdmin,
  listByAdmin,
  confirmUser,
  userDeletion,
};
